module.exports = __webpack_public_path__ + "static/media/ajax-Loader.8d0f8e2a.gif";